import React, {FC, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {fetchData, formatNumber, getTranslatedValue, toasterrormsg} from '../../../reusable'
import {PageTitle} from '../../../_metronic/layout/core'
import {RoomDetailsHeader} from './RoomDetailsHeader'
import Fancybox from '../Fancybox'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'


const RoomOverview: FC = () => {
  let t= Tr()
  const location = useLocation()
  const roomId = (location.state as any)?.roomId || ''
  const [roomDetails, setRoomDetails] = useState([])
const  lang = useLang()
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
    // Other options...
  }

  // room Details api call

  const roomDetailsApiCall = async () => {
    var param: any = {
      roomId: roomId,
    }
    var response: any = await fetchData('vendor/public/roomDetails', param)

    if (response.status == '200') {
      setRoomDetails(response.data)
      
    } else {
      toasterrormsg(response.message)
    }
  }
  const formatTime = (time: any) => {
    // Remove trailing ':00' from the time string
    return time.endsWith(':00') ? time.slice(0, -3) : time
  }
  useEffect(() => {
    roomDetailsApiCall()
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t("Room Overview")}</PageTitle>
      <ToastContainer />
      <RoomDetailsHeader />
      {roomDetails.map((room: any, index: any) => {
        // Parse the created date
        const createdDate = new Date(room['created'])

        // Add two years
        const createdDateTwoYearsLater = new Date(createdDate)
        createdDateTwoYearsLater.setFullYear(createdDate.getFullYear() + 2)

        // Check if dates are valid
        const isCreatedDateValid = !isNaN(createdDate.getTime())
        const isCreatedDateTwoYearsLaterValid = !isNaN(createdDateTwoYearsLater.getTime())

        // Parse availableDate into an array of objects
        const availableDates: any =  room['availableDate'] != "" ? JSON.parse(room['availableDate']) : null

        // Filter and map start dates for 'unavailable' type
        const unavailableDates: any = availableDates && availableDates
          .filter((date: any) => date.type === 'unavailable')
          .map((date: any) =>
            new Date(date.start).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            })
          )
        return (
          <div className='form' key={index}>
            {/* <!--begin::Card--> */}
            <div className='card'>
              {/* <!--begin::Card header--> */}
              <div className='card-header'>
                {/* <!--begin::Card header--> */}
                <div className='card-title fs-3 fw-bold'>{t("Basic Info")}</div>
                {/* <!--end::Card header--> */}
              </div>
              {/* <!--end::Card header--> */}
              {/* <!--begin::Card body--> */}
              <div className='card-body'>
                {room['en_roomName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Room Name (English)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {room['en_roomName']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['ru_roomName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Room Name (Russian)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {room['ru_roomName']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['uz_roomName'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Room Name (Uzbek)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {room['uz_roomName']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['standardPeople'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Standard People")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {room['standardPeople']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['maxPeople'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Maximum People")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>{room['maxPeople']}</div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>t{("General Information")}</div>
                </div>
                {room['en_generalInformation'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("General Information (English)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: room['en_generalInformation'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['ru_generalInformation'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("General Information (Russian)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: room['ru_generalInformation'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['uz_generalInformation'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("General Information (Uzbek)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: room['uz_generalInformation'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t("Facilities & Services")}</div>
                </div>
                {room['facilities'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Facilities & Services")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {room['facilities'].map((facilities: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-0'>
                                {getTranslatedValue(lang  , facilities , "_name")}
                                {index !== room['facilities'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['bedTypeDetail'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Bed Type")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {room['bedTypeDetail'].map((bedtype: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-0'>
                                {getTranslatedValue(lang  , bedtype , "_name")}
                                {index !== room['bedTypeDetail'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['roomTypeDetail'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Room Type")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {room['roomTypeDetail'].map((roomType: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-0'>
                                {getTranslatedValue(lang  , roomType , "_name")}
                                {index !== room['roomTypeDetail'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['bathRoomDetail'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Bathroom Type")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {room['bathRoomDetail'].map((bathroomType: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-0'>
                                {getTranslatedValue(lang  , bathroomType , "_name")}
                                {index !== room['bathRoomDetail'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {room['numberOfBathroom'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("No. Of Bath Room")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: room['numberOfBathroom'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['isSmokingAllowed'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t("Is smoking allowed in this studio?")}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: room['isSmokingAllowed'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t("Pricing & Availability")}</div>
                </div>
                {room['availableRoom'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t("Available rooms of the same type")}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: room['availableRoom'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                
                  
                {room['extraAdultCharge'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                          {t("Charge for per additional Person (By Day)")}
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>
                            {formatNumber(parseFloat(room['extraAdultCharge']))}{' '}
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['extraAdultChargeByHours'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>
                        {t("Charge for per additional Person (By hour)")}                    
                        </div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>
                            {formatNumber(parseFloat(room['extraAdultChargeByHours']))}{' '}
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {(room['bookByDay'] || room[' bookByTime']) && (
                  <div className='row mb-8'>
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("Booking Type")}</div>
                    </div>
                    <div className='col-xl-9'>
                      <div className='d-flex flex-column'>
                        <div className='fw-semibold text-gray-600 mt-3'>
                          {room['bookByDay'] === 1 && '✅ By Day'}
                          {room['bookByDay'] === 1 && room['bookByTime'] === 1 && ' '}
                          {room['bookByTime'] === 1 && '✅ By Hours'}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {room['bookByDay'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Room Price (By Day)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>
                            {formatNumber(parseFloat(room['baseCharge']))}{' '}
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['bookByTime'] ? (
                  <>
                    {/* Conditional Rendering for From and To Time */}
                    {(room['fromAvailableHours'] || room['toAvailableHours']) && (
                      <div className='row mb-8'>
                        {/* <!--begin::Col--> */}
                        <div className='col-xl-3'>
                          <div className='fs-6 fw-bold mt-2 mb-3'>{t("Available Hours")}</div>
                        </div>
                        {/* <!--end::Col--> */}

                        {/* <!--begin::Col--> */}
                        <div className='col-xl-9'>
                          <div className='d-flex flex-column'>
                            <div className='fw-semibold text-gray-600 mt-3'>
                              {room['fromAvailableHours'] && room['toAvailableHours'] && (
                                <div>
                                  From: {formatTime(room['fromAvailableHours'])} &nbsp;&nbsp;&nbsp;{' '}
                                  {/* Add space here */}
                                  To: {formatTime(room['toAvailableHours'])}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Col--> */}
                      </div>
                    )}
                  </>
                ) : (
                  ''
                )}
                {room['bookByTime'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Room Price (By Hours)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>
                            {formatNumber(parseFloat(room['baseChargeByHours']))}{' '}
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {room['availableDate'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Available Date")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div className='d-flex'>
                              <div>
                                {t("From:")}{' '}
                                {isCreatedDateValid
                                  ? createdDate.toLocaleDateString('en-GB', {
                                      day: '2-digit',
                                      month: 'long',
                                      year: 'numeric',
                                    })
                                  : 'Invalid date'}
                              </div>
                              <div className='date-separator'></div>
                              <div>
                                {t("To:")}{' '}
                                {isCreatedDateTwoYearsLaterValid
                                  ? createdDateTwoYearsLater.toLocaleDateString('en-GB', {
                                      day: '2-digit',
                                      month: 'long',
                                      year: 'numeric',
                                    })
                                  : 'Invalid date'}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {room['availableDate'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Un Available Date")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div className='d-flex'>
                              {unavailableDates.length > 0 && <>{unavailableDates.join(', ')}</>}
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t("Room photos")}</div>
                </div>

                {room['images'] && room['images'].length > 0 ? (
                  <div className='col-xl-12'>
                    {/* <!--begin::Engage widget 7--> */}
                    <div className='card card-flush h-xl-100'>
                      <div className='pt-7'>
                        <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                          {room['images'].map((menu: any, index: any) => {
                            return (
                              <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                <Fancybox options={opts}>
                                  {/* <!--begin::Overlay--> */}
                                  <a
                                    data-fancybox='gallery'
                                    className='d-block overlay'
                                    data-fslightbox='lightbox-hot-sales'
                                    href={menu['mediaPath']}
                                  >
                                    <div
                                      className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                      style={{
                                        height: '266px',
                                        backgroundImage: `url('${menu['mediaPath']}')`,
                                      }}
                                    ></div>
                                    {/* <!--end::Image--> */}

                                    {/* <!--begin::Action--> */}
                                    <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                      <i className='ki-outline ki-eye fs-3x text-white'></i>
                                    </div>
                                    {/* <!--end::Action-->       */}
                                  </a>
                                  {/* <!--end::Overlay--> */}
                                </Fancybox>

                                {/* Menu Name */}
                                <div className='text-center mt-2'>
                                  <h6>
                                    {menu['en_menuName'] ||
                                      menu['uz_menuName'] ||
                                      menu['ru_menuName']}
                                  </h6>
                                </div>
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Row--> */}
                      </div>
                      {/* <!--end::Card body--> */}
                    </div>
                    {/* <!--end::Engage widget 7--> */}
                  </div>
                ) : (
                  <div className='col-xl-12'>
                    {/* <!--begin::Engage widget 1--> */}
                    <div className='card h-md-100' dir='ltr'>
                      {/* <!--begin::Body--> */}
                      <div className='card-body d-flex flex-column flex-center'>
                        {/* <!--begin::Heading--> */}
                        <div className='mb-2'>
                          {/* <!--begin::Illustration--> */}
                          <div className='py-10 text-center'>
                            <img
                              src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                              className='theme-light-show h-125px'
                              alt=''
                            />
                            <img
                              src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                              className='theme-dark-show h-125px'
                              alt=''
                            />
                          </div>
                          {/* <!--end::Illustration--> */}
                        </div>
                        {/* <!--end::Heading--> */}
                      </div>
                      {/* <!--end::Body--> */}
                    </div>
                    {/* <!--end::Engage widget 1--> */}
                  </div>
                )}
              </div>
              
            </div>
            {/* <!--end::Card--> */}
          </div>
        )
      })}
    </>
  )
}

export {RoomOverview}
